module.exports = "/_next/static/Components/Proctortrack/10efa16b992d8bb52ad0c9da953a5999.png";